import React from "react"
import PropTypes from "prop-types"
import "./ResultCount.scss"

const ResultCount = props => {
  return (
    <div className="result-count-container">
      {props.loading ? null : (
        <div className="ResultCount">
          {props.deviceType === "desktop" ? null : (
            <div className="filter-icon" onClick={props.toggleFilterDropdown}>
              <img alt="Filter icon" src="/icons/filter-icon.svg" />
              <div
                className="filter-count"
                hidden={props.selectedFiltersCount < 1}
              >
                {props.selectedFiltersCount}
              </div>
            </div>
          )}
          Showing {props.resultCount}
          {props.resultCount === 1 ? " result " : " results "}
          as of {props.updateTime} ago
        </div>
      )}
    </div>
  )
}

ResultCount.propTypes = {
  resultCount: PropTypes.number,
  toggleFilterDropdown: PropTypes.func,
  deviceType: PropTypes.string.isRequired,
  selectedFiltersCount: PropTypes.number,
  loading: PropTypes.bool,
  updateTime: PropTypes.string,
}

export default ResultCount
